<template>
  <div class="innerwrapper" ref="innerwrapper">
    <div class="hot" ref="hot">
      <div class="hot-item" v-for="(item,index) in hotList" :key="index" @click="toDetail(item)">
        <van-image width="150" height="100" fit="cover" :src="publicUrl + item.quizMainPic" />
        <p class="van-ellipsis">{{item.quizName}}}</p>
        <span>{{handleUserCount(item.userCount)}}人已测</span>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "@p/api";
import publicUrl from "@p/public";
import VanImage from "@m/vant/Image";
import { handleUserCount } from "@p/util.js";
import Bscroll from "better-scroll";
export default {
  mixins: [VanImage],
  data() {
    return {
      publicUrl,
      hotList: [],
      hotLength: 0
      // scroll: null
    };
  },
  created() {
    this.getRecommendQuiz();
  },
  mounted() {},
  watch: {
    hotLength(val) {
      this.$refs.hot.style.width = val * 160 + "px"; // 修改滚动区域的宽度
      console.log(val);
      this.$nextTick(() => {
        if (!this.scroll) {
          this.scroll = new Bscroll(this.$refs.innerwrapper, {
            startX: 0, // 配置的详细信息请参考better-scroll的官方文档，这里不再赘述
            click: true,
            scrollX: true,
            scrollY: false,
            eventPassthrough: "vertical",
            bounce: false,
            stopPropagation: true
          });
        } else {
          this.scroll.refresh();
        }
      });
    }
  },
  methods: {
    handleUserCount,
    verScroll() {},
    async getRecommendQuiz() {
      var res = await api.requestApiByGet("recommendQuiz");
      console.log("热卖", res);
      if (res.code === 0) {
        this.hotList = res.data;
        this.hotLength = res.data.length;
        // this.verScroll();
      }
    },
    toDetail(item) {
      // this.$router.push({
      //   path: "/detail",
      //   query: {
      //     quizId: item.id
      //   }
      // });
      window.location = 'https://mp.weixin.qq.com/s/1oG8FoCwU0Um3A7w_4oi1Q'
    }
  }
};
</script>

<style lang="less" scoped>
.innerwrapper {
  width: calc(100% - 24px);
  overflow: hidden;

  margin: 0 auto;
}
.hot {
  display: flex;
  justify-self: center;

  .hot-item {
    padding: 0 5px;
    /deep/.van-image {
      img {
        border-radius: 4px;
      }
    }
    p {
      margin: 0 auto;
      width: 120px;
      line-height: 1.5;
      color: @gray-8;
      font-size: @font-size-lg;
      font-weight: @font-weight-bold;
    }
    span {
      width: 100%;
      text-align: center;
      display: block;
      color: @gray-6;
      font-size: @font-size-sm;
    }
  }
}
.hot::-webkit-scrollbar {
  display: none;
}
</style>
